<template>
  <div>
    <select
      name="sources"
      id="sources"
      class="custom-select sources"
      :placeholder="title"
    >
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
        :data-color="option.color || 'transparent'"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
// allow unamed function instead of () => {} for this file only
/* eslint func-names: ["error", "never"] */

import $ from 'jquery';

export default {
  props: {
    title: { default: '' },
    options: {
      type: Array,
      required: true,
    },
    selectedId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  mounted() {
    $('.custom-select').each(function () {
      const classes = $(this).attr('class');
      let template = `<div class="${classes}">`;
      template += `<span class="custom-select-trigger">${$(this).attr(
        'placeholder'
      )}</span>`;
      template += '<div class="custom-options">';
      $(this)
        .find('option')
        .each(function () {
          template += `<span class="custom-option" data-color="${$(this).attr(
            'data-color'
          )}" data-value="${$(this).attr('value')}">${$(this).html()}</span>`;
        });
      template += '</div></div>';

      $(this).wrap('<div class="custom-select-wrapper"></div>');
      $(this).hide();
      $(this).after(template);
    });
    $('.custom-option').each(function () {
      // Set the border color
      const color = $(this).attr('data-color');
      if (color) {
        $(this).css('border-left', `5px solid ${color}`);
      }
    });
    $('.custom-select-trigger').on('click', function (event) {
      $('html').one('click', function () {
        $('.custom-select').removeClass('opened');
      });
      $(this).parents('.custom-select').toggleClass('opened');
      event.stopPropagation();
    });

    const it = this;
    $('.custom-option').on('click', function () {
      const workspaceId = $(this).data('value');
      if (workspaceId) {
        $(this)
          .parents('.custom-select-wrapper')
          .find('select')
          .val(workspaceId);
        $(this)
          .parents('.custom-options')
          .find('.custom-option')
          .removeClass('selection');
        $(this).addClass('selection');
        $(this).parents('.custom-select').removeClass('opened');
        $(this)
          .parents('.custom-select')
          .find('.custom-select-trigger')
          .text($(this).text());
        it.$emit('change', workspaceId);
      }
    });

    this.selectDefaultItem();
  },
  methods: {
    selectDefaultItem() {
      if (this.selectedId) {
        // Click sur le selected
        const selectedOption = $(
          `.custom-option[data-value="${this.selectedId}"]`
        );
        selectedOption.trigger('click');
      }
    },
  },
  watch: {
    selectedId() {
      // Si le selected change
      this.selectDefaultItem();
    },
  },
};
</script>

<style lang="scss" src="./Select.scss"></style>
